/**
 * @author mrdoob / http://mrdoob.com/
 */

var Config = function () {

	var name = 'framejs-editor';

	var storage = {};

	if ( window.localStorage[ name ] !== undefined ) {

		var data = JSON.parse( window.localStorage[ name ] );

		for ( var key in data ) {

			storage[ key ] = data[ key ];

		}

	}

	return {

		getKey: function ( key ) {

			return storage[ key ];

		},

		setKey: function () { // key, value, key, value ...

			for ( var i = 0, l = arguments.length; i < l; i += 2 ) {

				storage[ arguments[ i ] ] = arguments[ i + 1 ];

			}

			window.localStorage[ name ] = JSON.stringify( storage );

			console.log( '[' + /\d\d\:\d\d\:\d\d/.exec( new Date() )[ 0 ] + ']', 'Saved config to LocalStorage.' );

		},

		clear: function () {

			delete window.localStorage[ name ];

		}

	};

};

export default Config


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/Config.js
// module id = null
// module chunks = 